import { Box, Container, Stack, Typography, useTheme } from '@mui/material';

import mainBg from '@/assets/imgs/home/main_slide_bg.png';
import mainSlideOverlay from '../../assets/imgs/home/main_slide_overlay.png';

import seoulMetroBanner from '@/assets/imgs/home/mainSlideBanners_v2/서울교통공사.png';
import korailBanner from '@/assets/imgs/home/mainSlideBanners_v2/한국철도공사.png';
import atBanner from '@/assets/imgs/home/mainSlideBanners_v2/한국농수산유통공사.png';
import molegBanner from '@/assets/imgs/home/mainSlideBanners_v2/법제처.png';
import mlitBanner from '@/assets/imgs/home/mainSlideBanners_v2/국토교통부.png';
import srBanner from '@/assets/imgs/home/mainSlideBanners_v2/에스알.png';
import mohwBanner from '@/assets/imgs/home/mainSlideBanners_v2/행안부.png';
import startupBanner from '@/assets/imgs/home/mainSlideBanners_v2/창업진흥원.png';
import komscoBanner from '@/assets/imgs/home/mainSlideBanners_v2/한국조폐공사.png';
import fscBanner from '@/assets/imgs/home/mainSlideBanners_v2/금융위원회.png';
import mofaBanner from '@/assets/imgs/home/mainSlideBanners_v2/외교부.png';
import ntsBanner from '@/assets/imgs/home/mainSlideBanners_v2/국세청.png';
import nccBanner from '@/assets/imgs/home/mainSlideBanners_v2/국립암센터.png';

import BusinessCarousel, { BusinessProps } from '@/components/carousel/BusinessCarousel';

import BusinessItem from './BusinessItem';
import BusinessItemMobile from './BusinessItemMobile';

import useIsMobile from '@/components/mobile/useInMobile';
import styles from './home.module.css';
// import BusinessItemHug from './BusinessItemHug';

export default function MainSlide() {
  const isMobile = useIsMobile();
  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        backgroundImage: `url(${mainBg})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        width: '100vw',
        height: '100vh',
      }}
    >
      <Box className={styles.imageWrapper}>
        <Box component="img" src={mainSlideOverlay} alt="오버레이 이미지" className={styles.overlayImage} />
      </Box>

      <Container maxWidth="xl">
        <Box component={'div'} className={`${styles.title}`}>
          {isMobile ? (
            <>
              <Box component={'div'}>
                <Box component={'span'} className={`${styles.bold}`}>
                  프람트테크놀로지
                </Box>
              </Box>
              <Box component={'div'}>데이터 개방을 넘어,</Box>
              <Box component={'div'}>공공혁신의 플랫폼을 만듭니다</Box>
            </>
          ) : (
            <>
              <Box component={'div'}>
                프람트테크놀로지는&nbsp;
                <Box component={'span'} className={`${styles.bold}`}>
                  공공데이터 개방
                </Box>
                을 넘어,
              </Box>
              <Box component={'div'}>
                <Box component={'span'} className={`${styles.bold}`}>
                  공공혁신의 플랫폼
                </Box>
                을 만듭니다.
              </Box>
            </>
          )}
        </Box>
        <Box component="div" className={`${styles.sub}`}>
          <Box component="div">
            <Box component={'span'} className={`${styles.bold}`}>
              국가중점데이터 개방
            </Box>
            과&nbsp;
            <Box component={'span'} className={`${styles.bold}`}>
              빅데이터 기반 솔루션
            </Box>
            을 통해
          </Box>
          <Box component="div">
            <Box component={'span'} className={`${styles.bold}`}>
              공공데이터의 가치
            </Box>
            를 극대화시킵니다.
          </Box>
        </Box>

        <Stack
          sx={{
            minHeight: '100vh',
          }}
        >
          <Box component="div" className={`${styles['business-carousel-wrapper']}`}>
            <BusinessCarousel
              elements={[
                <BusinessItem
                  businessImgUrl={seoulMetroBanner}
                  year="2025"
                  title={['서울지하철', '실시간 이용정보 서비스']}
                />,
                <BusinessItem
                  businessImgUrl={korailBanner}
                  year="2024"
                  title={['철도 지연열차', '승차권 확인 서비스']}
                />,
                <BusinessItem
                  businessImgUrl={atBanner}
                  year="2024"
                  title={['전국 도매시장', '실시간 경매 및 정산 정보']}
                />,
                <BusinessItem businessImgUrl={molegBanner} year="2024" title={['특정행정심판 재결례']} />,
                <BusinessItem businessImgUrl={molegBanner} year="2024" title={['중앙부처 법령해석']} />,
                <BusinessItem businessImgUrl={mlitBanner} year="2023" title={['사업용차량 이력정보']} />,
                <BusinessItem businessImgUrl={srBanner} year="2023" title={['SRT', '지연승차권 데이터']} />,
                <BusinessItem businessImgUrl={mohwBanner} year="2023" title={['재난배상 책임보험', '사업장 정보']} />,
                <BusinessItem businessImgUrl={korailBanner} year="2023" title={['열차운행 및', '역무편의시설 정보']} />,
                <BusinessItem businessImgUrl={startupBanner} year="2023" title={['창업지원 및', '교육데이터']} />,
                <BusinessItem
                  businessImgUrl={komscoBanner}
                  year="2023"
                  title={['종이형 지역사랑상품권', '판매, 환전 지점 정보']}
                />,
                <BusinessItem businessImgUrl={srBanner} year="2022" title={['SRT 회원 현황 정보']} />,
                <BusinessItem businessImgUrl={srBanner} year="2022" title={['SRT 승차권 정보']} />,
                <BusinessItem businessImgUrl={komscoBanner} year="2022" title={['지역사랑상품권', '가맹점 정보']} />,
                <BusinessItem
                  businessImgUrl={fscBanner}
                  year="2022"
                  title={['금융공공데이터 중', '개인정보사업자 정보']}
                />,
                <BusinessItem businessImgUrl={korailBanner} year="2021" title={['철도 열차', '승차권 진위확인']} />,
                <BusinessItem businessImgUrl={mofaBanner} year="2021" title={['해외안전 융합정보', '개방 확대']} />,
                <BusinessItem businessImgUrl={fscBanner} year="2021" title={['금융표준종합정보 DB', '개방 확대']} />,
                <BusinessItem businessImgUrl={ntsBanner} year="2021" title={['사업자등록정보', '진위확인']} />,
                <BusinessItem businessImgUrl={mofaBanner} year="2020" title={['해외안전', '융합정보']} />,
                <BusinessItem businessImgUrl={nccBanner} year="2019" title={['국가 암', '병기조사 데이터']} />,
              ]}
            />
          </Box>

          <Box component="div" className={`${styles['business-carousel-mobile-wrapper']}`}>
            <BusinessCarousel
              elements={[
                <BusinessItemMobile
                  businessImgUrl={seoulMetroBanner}
                  year="2025"
                  title={['서울지하철', '실시간 이용정보 서비스']}
                />,
                <BusinessItemMobile
                  businessImgUrl={korailBanner}
                  year="2024"
                  title={['철도 지연열차', '승차권 확인 서비스']}
                />,
                <BusinessItemMobile
                  businessImgUrl={atBanner}
                  year="2024"
                  title={['전국 도매시장', '실시간 경매 및 정산 정보']}
                />,
                <BusinessItemMobile businessImgUrl={molegBanner} year="2024" title={['특정행정심판 재결례']} />,
                <BusinessItemMobile businessImgUrl={molegBanner} year="2024" title={['중앙부처 법령해석']} />,
                <BusinessItemMobile businessImgUrl={mlitBanner} year="2023" title={['사업용차량 이력정보']} />,
                <BusinessItemMobile businessImgUrl={srBanner} year="2023" title={['SRT', '지연승차권 데이터']} />,
                <BusinessItemMobile
                  businessImgUrl={mohwBanner}
                  year="2023"
                  title={['재난배상 책임보험', '사업장 정보']}
                />,
                <BusinessItemMobile
                  businessImgUrl={korailBanner}
                  year="2023"
                  title={['열차운행 및', '역무편의시설 정보']}
                />,
                <BusinessItemMobile businessImgUrl={startupBanner} year="2023" title={['창업지원 및', '교육데이터']} />,
                <BusinessItemMobile
                  businessImgUrl={komscoBanner}
                  year="2023"
                  title={['종이형 지역사랑상품권', '판매, 환전 지점 정보']}
                />,
                <BusinessItemMobile businessImgUrl={srBanner} year="2022" title={['SRT 회원 현황 정보']} />,
                <BusinessItemMobile businessImgUrl={srBanner} year="2022" title={['SRT 승차권 정보']} />,
                <BusinessItemMobile
                  businessImgUrl={komscoBanner}
                  year="2022"
                  title={['지역사랑상품권', '가맹점 정보']}
                />,
                <BusinessItemMobile
                  businessImgUrl={fscBanner}
                  year="2022"
                  title={['금융공공데이터 중', '개인정보사업자 정보']}
                />,
                <BusinessItemMobile
                  businessImgUrl={korailBanner}
                  year="2021"
                  title={['철도 열차', '승차권 진위확인']}
                />,
                <BusinessItemMobile
                  businessImgUrl={mofaBanner}
                  year="2021"
                  title={['해외안전 융합정보', '개방 확대']}
                />,
                <BusinessItemMobile
                  businessImgUrl={fscBanner}
                  year="2021"
                  title={['금융표준종합정보 DB', '개방 확대']}
                />,
                <BusinessItemMobile businessImgUrl={ntsBanner} year="2021" title={['사업자등록정보', '진위확인']} />,
                <BusinessItemMobile businessImgUrl={mofaBanner} year="2020" title={['해외안전', '융합정보']} />,
                <BusinessItemMobile businessImgUrl={nccBanner} year="2019" title={['국가 암', '병기조사 데이터']} />,
              ]}
            />
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}
